import React, { useState, useEffect } from 'react';
// import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { control, useForm } from 'react-hook-form';
import { Box, Button, Grid, Container, Typography, Paper } from '@mui/material';
import dayjs from 'dayjs';
import _ from 'lodash';
import axios from 'axios';
import SaleProductform from '../../components/Forms/Gold/SaleProductForms';
import { ViewTitle } from '../../components/ViewTitle';
import TRANSACTION_TYPE from '../../utils/constants/transactionType.constant';
import * as actions from '../../redux/actions';
import useOrderCalculation from 'hooks/useOrderCalculation';
import { log } from 'addthaifont-pdfmake/build/pdfmake';

const Sale = ({ title, subtitle }) => {
  const location = useLocation();
  const { control, watch } = useForm();
  const customer = location.state;
  const placein = location.place;

  const [listorder, setListorder] = useState([]);
  const [listproduct, setListproduct] = useState([]);
  const [materialName, setMaterialName] = useState('');
  const [materialUnit, setMaterialUnit] = useState('');
  const [noMaterial, setNoMaterial] = useState('');
  const [materialTypeName, setmaterialTypeName] = useState('');
  const [materialTypeVat, setmaterialTypeVat] = useState('');
  const [goldPrice, setGoldprice] = useState(false);
  const [reload, setReload] = useState(false);
  const [totalListOrder, setTotalListOrder] = useState();
  const [payment, setPayment] = useState({});
  const [noteMaterial, setNoteMaterial] = useState('');
  const [placeName, setPlace] = useState('');
  const [materialTypeId, setmaterialTypeId] = useState();
  const [transactionDate, setTransactionDate] = useState(null);
  const [image, setImage] = useState([]);
  const [saving, setSaving] = useState(false);

  const renderTitle = () => (
    <ViewTitle title={`${title}`} subtitle={subtitle} />
  );
  const dispatch = useDispatch();

  const history = useHistory();
  const material = useSelector((state) => state.material);
  const materialType = useSelector((state) => state.materialType);
  const place = useSelector((state) => state.place);
  const me = useSelector((state) => state.me);
  const information = useSelector((state) => state.information);
  const bank = useSelector((state) => state.bank);
  const bankList = _.filter(bank?.rows, (b) => b.isCash === false);
  const cashList = _.filter(bank?.rows, (b) => b.isCash === true);
  const handleBack = () => {
    history.goBack(); // Go back one step in history
  };
  const GoldSell = parseFloat(
    (goldPrice?.price?.gold?.sell || '').replace(/,/g, ''),
  );
  const GoldBuy = parseFloat(
    (goldPrice?.price?.gold?.sell || '').replace(/,/g, ''),
  );
  const GoldBuyBar = parseFloat(
    (goldPrice?.price?.gold_bar?.sell || '').replace(/,/g, ''),
  );
  const GoldSellBar = parseFloat(
    (goldPrice?.price?.gold_bar?.buy || '').replace(/,/g, ''),
  );

  const { generateOrderData } = useOrderCalculation(listorder);

  const handleAddOrder = async () => {
    if (saving) return;
    if (!window.confirm('ยืนยันการบันทึกสินค้า ?')) return;

    try {
      setSaving(true); // เริ่มโหลด
      const totalPayment =
        (payment.cashStatus ? Number(payment?.cash) || 0 : 0) +
        (payment.transferStatus ? Number(payment?.transfer) || 0 : 0) +
        (payment.creditStatus ? Number(payment?.credit) || 0 : 0);
      if (totalPayment !== totalListOrder) {
        alert(
          `ยอดชำระ ${totalPayment} ไม่ตรงกับมูลค่ารวม ${totalListOrder} กรุณาตรวจสอบ`,
        );
        return;
      }

      const orderdatain = generateOrderData();
      // console.log('orderdatain', orderdatain);

      const DataOrder = {
        date: transactionDate != null ? transactionDate : dayjs().format(),
        customer: {
          name: customer?.name,
          cardId: customer?.cardID,
          tel: customer?.tel,
          born: customer?.born,
          address: customer?.address,
          tax: {
            taxnumber: customer?.tax?.taxnumber,
          },
          social: {
            facebook: customer?.social.facebook,
            line: customer?.social.email,
            email: customer?.social.email,
          },
          job: customer?.job,
        },
        saler: `${me?.userData?.firstname || ''} ${
          me?.userData?.lastname || ''
        }`,
        gold_transaction_type: TRANSACTION_TYPE?.SALE?.status_code,
        order: orderdatain,
        payment: {
          cash: {
            status: payment?.cashStatus,
            amount: payment?.cash,
            bank: cashList?.[0]?._id || null,
          },
          transfer: {
            status: payment?.transferStatus,
            amount: payment?.transfer,
            bank: payment?.bank?._id,
          },
          credit: {
            status: payment?.creditStatus,
            amount: payment?.credit,
          },
        },
        goldprice: {
          date: dayjs().format(),
          update_time: goldPrice?.update_time,
          price: {
            gold: {
              buy: GoldSell,
              sale: GoldBuy,
            },
            gold_bar: {
              buy: GoldBuyBar,
              sale: GoldSellBar,
            },
          },
        },
        user: {
          id: me?.userData?._id,
          firstname: me?.userData?.firstname,
          lastname: me?.userData?.lastname,
        },
      };

      await dispatch(actions.goldTransactionDecrease(DataOrder));
      alert('สำเร็จ');
      history.push('/gold/gold');
    } catch (error) {
      console.error('error', error);

      if (error?.message === 'UPLOAD_FAILED') {
        alert(
          '❌ อัปโหลดรูปไม่สำเร็จ รูปภาพอาจจะมีขนาดใหญ่ลดขนาดและกรุณาลองใหม่อีกครั้ง',
        );
        return;
      }
      alert('เกิดข้อผิดพลาด: ' + (error?.message || 'ไม่ทราบสาเหตุ'));
    } finally {
      setSaving(false);
    }
  };
  useEffect(() => {
    dispatch(actions.materialAll({ name: '', page: 1 }));
    dispatch(actions.bankAll({ name: '', page: 1 }));

    return () => {};
  }, []);
  useEffect(() => {
    try {
      axios.get('https://psu-thaigold.eappsoft.net/latest').then((res) => {
        setGoldprice(res.data?.response);
      });
    } catch (error) {
      console.error('Error', error?.message);
    }
    return () => {};
  }, [reload]);

  return (
    <div>
      {renderTitle()}
      <Box
        sx={{
          position: 'relative',
          padding: 1,
        }}
      >
        {/* ปุ่มกลับ */}
        <Button
          variant="outlined"
          sx={{
            position: 'relative',
            right: 16,
            borderColor: 'green',
            color: 'green',
          }}
          onClick={handleBack}
        >
          กลับ
        </Button>{' '}
      </Box>
      <SaleProductform
        placein={placein}
        listorder={listorder}
        material={material}
        setListorder={setListorder}
        handleAddOrder={handleAddOrder}
        materialType={materialType}
        listproduct={listproduct}
        setListproduct={setListproduct}
        place={place}
        materialTypeId={materialTypeId}
        setmaterialTypeId={setmaterialTypeId}
        placeName={placeName}
        transactionDate={transactionDate}
        setTransactionDate={setTransactionDate}
        setPlace={setPlace}
        materialName={materialName}
        me={me}
        setMaterialName={setMaterialName}
        materialUnit={materialUnit}
        setMaterialUnit={setMaterialUnit}
        noMaterial={noMaterial}
        setNoMaterial={setNoMaterial}
        materialTypeName={materialTypeName}
        setmaterialTypeName={setmaterialTypeName}
        materialTypeVat={materialTypeVat}
        setmaterialTypeVat={setmaterialTypeVat}
        payment={payment}
        setPayment={setPayment}
        setTotalListOrder={setTotalListOrder}
        setNoteMaterial={setNoteMaterial}
        noteMaterial={noteMaterial}
        goldPrice={goldPrice}
        bank={bank?.rows || []}
        bankList={bankList}
        cashList={cashList}
        image={image}
        setImage={setImage}
      />
      <div className="flex flex-row justify-center  pr-gap-1 ">
        <Button variant="contained" onClick={() => handleAddOrder()}>
          {saving ? 'กำลังบันทึก...' : 'บันทึก'}
        </Button>
      </div>
    </div>
  );
};

export default Sale;
